import { paramCase, capitalCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// routes

// sections

import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useLocales from 'src/hooks/useLocales';
import useSettings from 'src/hooks/useSettings';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import TermsAndConditionNewEditForm from './TermsAndConditionNewEditForm';
// ----------------------------------------------------------------------

export default function TermsAndConditionCreate() {
  const { themeStretch } = useSettings();

  const { pathname } = useLocation();
  const { translate } = useLocales();
  const { name = '' } = useParams();

  const isEdit = pathname.includes('edit');

  return (
    <Page
      title={
        !isEdit
          ? `${translate('TermAndCondition.CreateTitle')}`
          : `${translate('TermAndCondition.UpdateTitle')}`
      }
    >
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={
            !isEdit
              ? `${translate('TermAndCondition.CreateTitle')}`
              : `${translate('TermAndCondition.UpdateTitle')}`
          }
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('TermAndCondition.TermAndConditionList')}`,
              href: PATH_DASHBOARD.TermsAndCondition.list,
            },
            {
              name: !isEdit
                ? `${translate('TermAndCondition.CreateTitle')}`
                : `${translate('TermAndCondition.UpdateTitle')}`,
            },
          ]}
        />
        <TermsAndConditionNewEditForm />
      </Container>
    </Page>
  );
}
